function Dashboard() {
    return (
        <>
            Dashboard 
        </>
    );
}

export default Dashboard;